export enum UserTypeEnum {
    UNKNOWN = -1,
    SURVEYOR = 1,
    EXPERT = 2,
    MANAGER = 3,
    CLIENT = 4,
    DO = 5,
    EXPERT_SURVEYOR = 10
}